import './scss/index.scss';
import 'owl.carousel';
import { dcFactory } from 'dc';
import RelatedAdviceSliderComponent from './js/related-advice.component';

dcFactory.register(RelatedAdviceSliderComponent);
